export default "<router-outlet>"